import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { FIREBASE_COLLECTIONS } from "../Component/api/url";

export type PlanNotificationType =
  | "meal_plan"
  | "water_plan"
  | "exercise_plan"
  | "supplement_plan"
  | "guideline_plan";

const NOTIFICATION_CONTENT: Record<
  PlanNotificationType,
  { heading: string; content: string }
> = {
  meal_plan: {
    heading: "👋 Hey! Your Meal Plan is Here",
    content: "Your meal plan is live 🎉 Let's get started!",
  },
  water_plan: {
    heading: "💧 Stay Hydrated — Water Plan Ready",
    content: "Your new water intake plan is live. Let's sip to a healthier you!",
  },
  exercise_plan: {
    heading: "🏋️ Time to Move — Exercise Plan Ready",
    content: "Your exercise plan is here. Let's build that strength!",
  },
  supplement_plan: {
    heading: "💊 Your Supplement Plan is Ready",
    content: "Check out your new supplement schedule and stay on track.",
  },
  guideline_plan: {
    heading: "📘 New Guideline Just for You",
    content: "Your nutritionist shared a new guideline — give it a read!",
  },
};

async function fetchClientPlayerId(
  userId: string | number,
): Promise<string | undefined> {
  try {
    const userDocRef = doc(
      db,
      FIREBASE_COLLECTIONS.USERS,
      `userid_${userId}`,
    );
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      return userDoc.data()?.playerId || undefined;
    }
  } catch (err) {
    console.error("Failed to fetch OneSignal playerId:", err);
  }
  return undefined;
}

export async function sendPlanNotificationToUser(
  userId: string | number,
  type: PlanNotificationType,
): Promise<void> {
  const playerId = await fetchClientPlayerId(userId);
  if (!playerId) return;

  const { heading, content } = NOTIFICATION_CONTENT[type];

  try {
    const response = await fetch("https://api.onesignal.com/notifications", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_ONESIGNAL_API_KEY as string,
      },
      body: JSON.stringify({
        app_id: process.env.REACT_APP_ONESIGNAL_APP_ID,
        include_player_ids: [playerId],
        headings: { en: heading },
        contents: { en: content },
        data: { type },
      }),
    });

    if (!response.ok) {
      console.error(
        "Failed to send OneSignal notification:",
        response.status,
      );
    }
  } catch (err) {
    console.error("Error sending OneSignal notification:", err);
  }
}
